<ng-container *ngIf="!isOther">
  <div *ngIf="offer" class="offer" [class.highlighted]="offer.highlighted">
    <span class="price strikethrough" *ngIf="priceIsOverridden">
      <ng-container *ngIf="offer.membership_product.price % 100 == 0">
        {{ offer.membership_product.price / 100 | currency:'USD' : 'symbol' : '1.0' }}
      </ng-container>
      <ng-container *ngIf="offer.membership_product.price % 100 != 0">
        {{ offer.membership_product.price / 100 | currency:'USD' : 'symbol' : '1.2' }}
      </ng-container>
    </span>
    <span class="price" [class.overridden-price]="priceIsOverridden">
      <ng-container *ngIf="offer.price % 100 == 0">
        {{ offer.price / 100 | currency:'USD' : 'symbol' : '1.0' }}
      </ng-container>
      <ng-container *ngIf="offer.price % 100 != 0">
        {{ offer.price / 100 | currency:'USD' : 'symbol' : '1.2' }}
      </ng-container>
    </span>
    <span class="period" [class.overridden-price]="priceIsOverridden">{{ frequencySuffixForPeriod(offer.period) }}</span>
    <span class="spacer"></span>
    <span class="info">
      <!-- place labels like "Suggested Price", "Not Available" etc here -->
      <ng-container *ngIf="offer.subsidized">
        <ng-container *ngIf="offer.sponsorship_available">
          
        </ng-container>
        <ng-container *ngIf="!offer.sponsorship_available">
          Not Available At This Time
        </ng-container>
      </ng-container>
      <ng-container *ngIf="offer.sponsorship_count > 0">
        Unlocks {{offer.sponsorship_count}} 
        <ng-container *ngIf="subsidizedPrice % 100 == 0">
          {{subsidizedPrice / 100 | currency:'USD' : 'symbol' : '1.0' }}
        </ng-container>
        <ng-container *ngIf="subsidizedPrice % 100 != 0">
          {{subsidizedPrice / 100 | currency:'USD' : 'symbol' : '1.2' }}
        </ng-container>
        memberships
      </ng-container>
      <ng-container *ngIf="offer.highlighted && offer.highlight_text">
        {{offer.highlight_text}}
      </ng-container>
    </span>
  </div>
  <a *ngIf="offer.benefits" (click)="buttonClick($event)" class="more-info">
    <tyt-tooltip-button>
      <button>
        <img class="invert-on-dark" src="/assets/offers/more-info.svg">
      </button>
      <div class="popout">{{ offer?.benefits }}</div>
    </tyt-tooltip-button>
  </a>
</ng-container>
<ng-container *ngIf="isOther">
  <div class="offer">
    <span class="price">Name Your Amount</span>
  </div>
</ng-container>

